import {useNavigation} from "@react-navigation/native";
import React, {useContext} from "react";
import {DimensionsContext} from "@common/utils/mobileUtils";
import {theme} from "@common/theme/theme";
import {connect} from "react-redux";
import {apiIdle, apiRequest} from "@data/redux/actions/api";
import {hasRole} from "@data/utility/ability";
import TextM from "@common/components/text/TextM";
import {View} from "react-native";
import DownloadAppButton from "../../student/tutoring/DownloadAppButton";

function DownloadAppCard(props) {
    const { navigation } = props;
    const dimensions = useContext(DimensionsContext);

    const title = hasRole(props.user, "student") ? "Télécharge l’application mobile pour faciliter l’envoi de photos de ton travail" : "Télécharge l’application mobile pour recevoir les notifications";
    const description = hasRole(props.user, "student") ? "Tu peux te connecter au Live sur PC, et utiliser l’appli à côté pour prendre des photos de ton travail" : "C’est pratique pour échanger avec tes élèves en dehors des séances et gérer l’organisation. Mais attention, pour animer un live il te faut impérativement un PC (ou éventuellement une tablette).";

    return (
        <View style={{
            width: dimensions.width,
            alignSelf: "center",
            paddingHorizontal: 20,
            alignItems: "center",
            marginTop: 20,
            paddingBottom: 40,
            ...props.style
        }}>
            <TextM
                fontWeight={"Bold"}
                color={theme.colors.primary}
                wrap
                fontSize={18}
                style={{
                    maxWidth: "90%",
                    textAlign: "center"
                }}
            >
                {title}
            </TextM>
            <TextM
                wrap
                style={{
                    marginTop: 10,
                    textAlign: "center"
                }}
                color={theme.colors.primary}
            >
                {description}
            </TextM>

            <DownloadAppButton style={{
                flexDirection: "row",
                gap: 20,
            }}/>
        </View>
    );
}

const mapStateToProps = (state) => {
    return {
        user: state.data.currentUser?.object,
        updateStatusRequest: state.api.updateStatus?.request
    };
};

const mapDispatchToProps = {
    apiRequest,
    apiIdle
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DownloadAppCard);
